var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPush = function SvgPush(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5a8.47 8.47 0 0 1 8.5 8.5c0 2.3-.91 4.39-2.4 5.91l-1.08.95a8.5 8.5 0 0 1-10.04 0l-1.08-.95A8.48 8.48 0 0 1 12 4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M12 13v6m0-6-4.14 2.24M6.4 2.4a12.07 12.07 0 0 0-4.77 4.56M17.6 2.4a12.07 12.07 0 0 1 4.77 4.56"
  }))));
};
export default SvgPush;